import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './hermeneus.window/window.js'
import './hermeneus.vue-instance/hermeneus.vue-instance.js'
import './hermeneus.reader/js/reader.class_reader.js'

const app = createApp({})
const pinia = createPinia()

app.use(pinia)
